import React from "react";
import { DurationOverTimeChart } from "./Chart";
import { SinglePageView } from "../core/ListView";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import { useGamePlayTests } from "@seabrookstudios/pitch2table";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/types").GameId} props.gameId
 */
export const DurationOverTime = ({ gameId }) => {
  const { data: playTests = [] } = useGamePlayTests(gameId);

  const playTestsWithDuration = playTests.filter((pt) => pt.duration && pt.ignore);
  const incompletePlayTests = playTests.filter((pt) => !pt.duration && pt.ignore);

  return (
    <SinglePageView title={`Duration Over Time`}>
      {playTestsWithDuration.length === 0 ? (
        <Box p={1}>
          <Alert severity="warning">
            To use this chart you need to record duration for your play tests. Update your play tests to include
            duration information.
          </Alert>
        </Box>
      ) : (
        <Box p={1}>
          <Alert severity="info">
            This chart shows how play test duration changes over time. Only play tests with recorded duration are
            included.
            {incompletePlayTests.length > 0 && (
              <>
                {" "}
                There are {incompletePlayTests.length} play test{incompletePlayTests.length === 1 ? "" : "s"} without
                duration data.
              </>
            )}
          </Alert>
        </Box>
      )}
      <DurationOverTimeChart gameId={gameId} />
    </SinglePageView>
  );
};
